'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

TimelineSettingsConfig=class TimelineSettingsConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('timelineSettings');
$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=TimelineSettingsConfig;
//# sourceMappingURL=timelineSettingsConfig.js.map
